import { ReactNode } from 'react';

import Icon from '@/common/components/Icon/Icon';
import { IconName } from '@/common/components/Icon/iconName';

import GlobalAccessRadio from '../GlobalAccessRadio/GlobalAccessRadio';

import styles from './GlobalDataAssessRadio.module.css';

export interface GlobalDataAssessRadioProps {
  checked: boolean;
  description?: ReactNode;
  disabled?: boolean;
  iconName: IconName;
  id: number;
  isAmbient?: boolean;
  onChange: (id: number) => void;
  title: ReactNode;
  'aria-label'?: string;
}

function GlobalDataAssessRadio(props: GlobalDataAssessRadioProps) {
  const {
    checked,
    description,
    disabled = false,
    iconName,
    id,
    isAmbient = false,
    onChange,
    title,
    'aria-label': ariaLabel,
  } = props;

  return (
    <GlobalAccessRadio
      aria-label={ariaLabel}
      checked={checked}
      description={description}
      disabled={disabled}
      icon={<Icon className={styles.optionDataIcon} name={iconName} />}
      isAmbient={isAmbient}
      onChange={() => onChange(id)}
      title={title}
    />
  );
}

export default GlobalDataAssessRadio;
